'use client';

import CategoryPage from '@/joystagram-components/components/consumer/CategoryPage';
import { PAGE_TYPE } from '@/joystagram-components/components/consumer/category-page-algolia/categoryPageTypes';
import WarehouseIdHydrator from '@/joystagram-components/global-state/warehouseIdForUser/WarehouseIdHydrator';

// The Algolia-backed `/instock/` page (CON-8567). Unlike CategoryPageClient
// there is no `serverCategoryData`: the READY_TO_SHIP descriptor supplies all
// metadata (no Alexandria page exists behind the `instock` pseudo-slug), the
// legacy page had zero server prefetch, and warehouse-dependent products must
// never go through the slug-keyed `'use cache'` helpers.
export default function QuickshipPageClient({ serverWarehouseId }) {
  return (
    <WarehouseIdHydrator warehouseId={serverWarehouseId}>
      <CategoryPage slug="instock" pageType={PAGE_TYPE.READY_TO_SHIP} />
    </WarehouseIdHydrator>
  );
}
